// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"fd8cb0ca","638":"a0bb1920"}[chunkId] + ".chunk.js";
};